"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var reporting_service_1 = require("./reporting-service");
var paging_criteria_1 = require("./paging-criteria");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var report_options_1 = require("./report-options");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var core_1 = require("@angular/core");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var http_1 = require("@angular/common/http");
/**
 * Created by Hayk.Andriasyan on 5/30/2017.
 */
var HttpReportingService = /** @class */ (function (_super) {
    __extends(HttpReportingService, _super);
    function HttpReportingService(http, applicationPropertiesService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.serviceApiUrlKey = 'reporting-service-url';
        _this.reportServiceEndpoint = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/execute-report"], ["", "/execute-report"])), 'serviceUri');
        _this.loadedServiceUrl = applicationPropertiesService
            .getProperty(_this.serviceApiUrlKey)
            .catch(_this.handleError);
        return _this;
    }
    HttpReportingService.prototype.executeReport = function (report, filters, languageId, dataSetId, reportOptions, pagingCriteria) {
        if (!reportOptions) {
            reportOptions = new report_options_1.ReportOptions();
        }
        if (!Number.isInteger(reportOptions.timezoneOffset)) {
            reportOptions.timezoneOffset = -(new Date().getTimezoneOffset()) * 60;
        }
        return this.getReportJsonPromise(report, filters, languageId, reportOptions, pagingCriteria || paging_criteria_1.PagingCriteria.all(), dataSetId);
    };
    HttpReportingService.prototype.getReportJsonPromise = function (report, filters, languageId, reportOptions, pagingCriteria, dataSetId) {
        var _this = this;
        return this.loadedServiceUrl.then(function (url) {
            return _this.getReportJsonHttp(url, report, filters, languageId, reportOptions, pagingCriteria, dataSetId).toPromise();
        });
    };
    HttpReportingService.prototype.getReportJsonHttp = function (url, report, filters, languageId, reportOptions, pagingCriteria, dataSetId) {
        var headers = new http_1.HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        var params = new http_1.HttpParams()
            .set('report', JSON.stringify(report))
            .set('filters', filters.toJson())
            .set('languageId', languageId.toString())
            .set('reportOptions', reportOptions.toJson())
            .set('dataSetId', dataSetId.toString())
            .set('pagingCriteria', pagingCriteria.toJson());
        return this.http.post(this.reportServiceEndpoint.replaceTemplate({ serviceUri: url }), params.toString(), { headers: headers });
    };
    /**
     * Handle errors
     */
    HttpReportingService.prototype.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        console.error(errMsg);
        return Promise.reject(errMsg);
    };
    HttpReportingService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpReportingService);
    return HttpReportingService;
}(reporting_service_1.ReportingService));
exports.HttpReportingService = HttpReportingService;
var templateObject_1;
//# sourceMappingURL=http-reporting-service.js.map